// "Which program fits me?" quiz — questions, scoring and result resolution.

export const QUIZ_QUESTIONS = [
  {
    id: "goal",
    title: "What's your #1 goal right now?",
    options: [
      { label: "Transform my body — lose fat, build muscle", scores: { "body-transformation": 3 } },
      { label: "Fix my energy & metabolism", scores: { "metabolic-optimization": 3 } },
      { label: "Sharper focus & mental clarity", scores: { "cognitive-optimization": 3 } },
      { label: "Perform at a higher level — sport or work", scores: { "performance-optimization": 3 } },
      { label: "Live longer, age slower", scores: { "longevity-optimization": 3 } },
      { label: "Balance my hormones — energy, libido, mood", scores: { "hormone-optimization": 3 } },
      { label: "Get a complete picture of my health", scores: { "health-optimization": 3 } },
    ],
  },
  {
    id: "state",
    title: "Which best describes you today?",
    options: [
      { label: "I have symptoms or a diagnosed condition to address", scores: { medical: 3 } },
      { label: "Generally healthy — I want to optimize", scores: { "health-optimization": 1 } },
      { label: "Training hard, but progress has stalled", scores: { "performance-optimization": 2, "body-transformation": 1 } },
      { label: "Run down — poor sleep, stress, slow recovery", scores: { "hormone-optimization": 1, "metabolic-optimization": 1, "cognitive-optimization": 1 } },
    ],
  },
  {
    id: "style",
    title: "What matters most in a program?",
    options: [
      { label: "Physician oversight & medical options", scores: { medical: 2, "hormone-optimization": 1 } },
      { label: "Deep data — labs, DNA, microbiome, wearables", scores: { "health-optimization": 2 } },
      { label: "Training & nutrition engineered around me", scores: { "body-transformation": 2, "performance-optimization": 1 } },
      { label: "A long-term healthspan strategy", scores: { "longevity-optimization": 2 } },
    ],
  },
  {
    id: "age",
    title: "Your age bracket?",
    options: [
      { label: "Under 35", scores: { "performance-optimization": 1, "body-transformation": 1 } },
      { label: "35–50", scores: { "metabolic-optimization": 1, "hormone-optimization": 1 } },
      { label: "50+", scores: { "longevity-optimization": 1, "hormone-optimization": 1 } },
    ],
  },
];

export const MEDICAL_RESULT = {
  title: "Physician-Guided Optimization",
  pitch:
    "Your answers point to starting with the clinical side of the Integrated Optimization Program — physician-guided diagnostics and treatment, with the same data engine and daily coaching built around it.",
  image: "https://iwmc-body-app.emergent.host/static/media/program-metabolic.9902a0e4d5d0d4480b71.webp",
  href: "/medical-care",
  linkLabel: "How Physician Oversight Works",
};

export function resolveResult(answers) {
  const scores = {};
  let medical = 0;
  answers.forEach((opt) => {
    Object.entries(opt.scores).forEach(([key, val]) => {
      if (key === "medical") medical += val;
      else scores[key] = (scores[key] || 0) + val;
    });
  });
  // Q1 goal pick wins ties
  const goalSlug = Object.keys(answers[0].scores)[0];
  let top = goalSlug;
  let topScore = scores[goalSlug] || 0;
  Object.entries(scores).forEach(([slug, s]) => {
    if (s > topScore) {
      top = slug;
      topScore = s;
    }
  });
  return { medical: medical >= 3, slug: top };
}
